module.exports = __webpack_public_path__ + "static/media/banner.466fb921.png";